export default __webpack_public_path__ + "static/media/Ubereats1.488c13dc.svg";